module.exports = __webpack_public_path__ + "static/media/7.4ad84a01.JPG";